const labels = {
  lbl_once_off_only: "Once-off only",
  lbl_add_to_compare: "Add to compare",
  lbl_added_to_compare: "Added to compare",
  lbl_preorder_now: "Pre-order now!",
  lbl_buy_now: "Buy now",
  lbl_see_details: "See details",
  lbl_your_cart: "Your cart",
  lbl_add_to_cart: "Add to cart",
  lbl_add_to_bundle: "Add this to bundle",
  lbl_about_to_purchase: "You’re about to purchase:",
  lbl_quantity: "Qty:",
  lbl_promotion: "Promotion:",
  lbl_move_to_wishlist: "Move to my wishlist",
  lbl_remove: "Remove",
  lbl_sub_total: "Sub-total:",
  lbl_total_once_off_due: "Total due now:",
  lbl_total_saving: "Total saving:",
  lbl_order_summary: "Order summary",
  lbl_delivery: "Delivery:",
  lbl_vat: "VAT (incl.):",
  lbl_reset: "Reset",
  lbl_total: "Total:",
  lbl_total_due: "Total due now:",
  lbl_total_paid: "Total paid:",
  lbl_checkout_now: "Checkout now",
  lbl_promocode_query: "Got a promo code or voucher?",
  lbl_enter_promo: "Enter promo / voucher code",
  lbl_apply_code: "Apply code",
  lbl_change_storage: "Change storage size",
  lbl_change_storage_or_color: "Change storage or color",
  lbl_change_color: "Change colour",
  lbl_view_product_details: "View product details",
  lbl_move_product_to_wishlist: "Move product to my wishlist",
  lbl_remove_from_cart: "Remove product from my cart",
  lbl_remove_deal_from_cart: "Remove deal from my cart",
  lbl_deal_remove_from_cart: "has been removed from your cart",
  lbl_why_shop_online: "WHY SHOP ONLINE?",
  lbl_free_delivery: "FREE delivery",
  lbl_paid_delivery: "Get FREE delivery ",
  lbl_free_delivery_text: "when you spend R600 or more.",
  lbl_click_collect: "This order can be collected from a Vodacom Shop ",
  lbl_click_collect_normal:
      "You can choose between delivery or collection options during checkout.",
  lbl_on_orders: "on orders over R600",
  lbl_orders_service_down:
      "We seem to be having some issues fetching your past orders. Please try again later.",
  lbl_easy_returns: "Easy returns",
  lbl_delivery_within: "within 14 days of delivery",
  lbl_all_secure: "100% secure",
  lbl_online_checkout: "online checkout & payment",
  lbl_price_type: "Price type:",
  lbl_sort_by: "Sort by",
  lbl_filter_products: "Filter products",
  lbl_filter_device: "Filter by product",
  lbl_filter_device_mobile: "Filter by product",
  lbl_more_filters: "More filters",
  lbl_recommend_for_you: "Recommended for you",
  lbl_cart_items: "itemno products have been added to your cart",
  lbl_cart_item: "1 product has been added to your cart",
  lbl_removed_from_cart: "has been removed from  your cart",
  lbl_updated_cart: "The product quantity has been updated",
  lbl_free: "Free",
  lbl_view_cart: "View my cart",
  lbl_continue_shopping: "Continue shopping",
  lbl_item_add_success: "This item has been added to your cart",
  lbl_empty_cart_msg: "You don’t have anything in your cart yet",
  lbl_in_stock: "IN_STOCK",
  lbl_out_of_stock: "OUT_OF_STOCK",
  lbl_once_off_purchase: "ONCE-OFF PURCHASE",
  lbl_monthly_purchase: "NEW CONTRACT",
  lbl_upgrade_purchase: "UPGRADE",
  lbl_app_type: "Application type:",
  lbl_contract_duration: "Contract duration:",
  lbl_add_Ons: "Add-ons:",
  lbl_deal: "Deal",
  lbl_monthly_subtotal: "Monthly sub-total:",
  lbl_onceoff_subtotal: "Once-off sub-total:",
  lbl_once_off_item_count: "Number of once-off items:",
  lbl_monthly_total: "Monthly total:",
  lbl_onceoff_total: "Total due now:",
  lbl_cart_max_item: 6,
  lbl_cart_min_product_add_qty: 1,
  lbl_international_calling_costs: "International Calling costs",
  lbl_cart_items_max_msg:
      "The total number of items in your cart exceeds the maximum allowed. Please reduce your cart to less than <XY> items.",
  lbl_cart_order_max_msg:
      "Your cart total exceeds the maximum amount allowed. Please remove items to reduce your total to <RXX> or less.",
  lbl_out_of_stock_msg:
      "An item in your cart is currently out of stock. Please remove it before checking out.",
  lbl_only_one_type_product:
      "Unfortunately, you can only check out one type of product at a time - either a monthly contract or one or more once-off purchase items. Please remove either the contract or once-off items from your cart in order to continue to checkout.",
  lbl_only_one_deal_allowed:
      "You can only apply for one contract at a time. Please remove 1 deal from your cart before checking out.",
  lbl_only_uniq_vas_allowed:
      "You have two of the same add-ons in your cart. Please remove one of them before continuing to checkout.",
  lbl_add_up_to_four:
      "You can only add up to 4 add-ons to your contract. Please remove any excess add-ons before continuing to checkout.",
  lbl_no_items: "Number of items:",
  lbl_another_deal: "Choose another deal",
  lbl_invalid_coupon:
      "The voucher code you've entered is invalid. Please try again.",
  lbl_promo_text: "PROMO CODE / VOUCHER",
  lbl_coupon_applied_successfully:
      "Your voucher discount has been applied to your cart.",
  lbl_magento_invalid_coupon_error:
      "The coupon code isn't valid. Verify the code and try again.",
  lbl_coupon_code_removed_successfully:
      "Your voucher discount has been removed from your cart",
  lbl_out_of_stock_description:
      "We expect to have this product back in stock in 2 - 3 weeks",
  lbl_out_of_stock_title: "Currently out of online stock",
  // lbl_nearest_store_stock_description: "This store near you has stock:",
  lbl_click_and_collect_msg: "Click and Collect may or may not be available, depending on what's included in your order at checkout",
  lbl_multi_onceoff_msg: "Your monthly contract payment will only be deducted via debit order once your application has been processed",
  lbl_current_user_cannot_perform_operation_on_cart: "The current user cannot perform operations on cart",
  lbl_could_not_find_cart_id: "Could not find a cart with ID",
  lbl_available_pre_order_only: "Available for pre-order only",
  lbl_available_pre_order_only_desc:
      "We expect this product to sell fast.  Pre-order today to make sure you don't miss out!",
  lbl_pre_order_browse_all: "Browse all",
  lbl_pre_order_online_exclusive_tag: "Online Exclusive",
  lbl_pre_order_deal_message:
      "Apply for this deal today and be one of the first customers to get your order delivered when this product becomes available",
  lbl_no_store_list_found: "Oops! We seem to have an issue showing store information right now. Please select the delivery option, or try again later.",
  lbl_store_reservation_business_error: "store_reservation_business_error",
  lbl_store_reservation_technical_error: "store_reservation_technical_error",
  lbl_affordability_product_filter: "We'll show you search results based on your affordability",
  BreadCrumbLabels: {
    lbl_home: "Home",
    lbl_browse_products: "Browse products",
    lbl_all_products: "All products",
    lbl_compare_products: "Compare products",
    lbl_product_details: "Product details",
    lbl_cart: "Cart",
    lbl_hidden_breadCrumb_for_mobile: "...",
    items_display_before_collapser_mbl: 1,
    items_display_after_collapser_mbl: 2,
    max_display_items_mbl: 3,
    lbl_shop: "Shop",
    lbl_browse_all_deals: "Browse all deals",
    lbl_order_details: "Order details",
    lbl_order_history: "Order History",
    lbl_deal_details: "Deal details",
    lbl_upgrade_page: "Upgrade",
    lbl_track_order: "Track my order",
  },
  productBottomFooterTabs: {
    lbl_similar_products: "Similar products",
    lbl_related_products: "Related products",
    lbl_brand_new: "More from",
    lbl_brand: "Brand",
    max_products: 6,
  },
  productBottomFooterTabArr: [
    {
      key: "SMP",
      title: "Similar products",
    },
    {
      key: "RLP",
      title: "Related products",
    },
    {
      key: "BRAND",
      title: "More from",
    },
  ],
  lbl_product_typeName_configurable: "ConfigurableProduct",
  lbl_product_typeName_simple: "SimpleProduct",
  lbl_product_type_bundle: "BundleProduct",
  lbl_discount_end_text: "Discount ends in",
  lbl_promotion_tag_link: "See our great deals",
  lbl_promotion_tag_text: "for this product",
  Session_Keys: {
    lbl_breadCrumb: "BreadCrumb",
    lbl_list_page_router_with_filters: "ListPageRouterWithFilters",
    lbl_page_visit_history: "PageVisitHistory",
    lbl_cart_summary: "dealGroupIds",
  },
  lbl_continue_with_checkout: "Continue with checkout",
  lbl_exit_checkout: {
    desktop: "Exit checkout",
    mobile: "Exit",
  },
  lbl_checkout_header: {
    title: "Secure checkout",
  },
  sortKeys: {
    lbl_most_popular: "Most popular",
    lbl_low_to_high: "Price - Low to high",
    lbl_new_to_old: "Latest to oldest",
    lbl_old_to_new: "Oldest to newest",
    lbl_high_to_low: "Price - High to low",
    lbl_recommended: "Recommended",
  },
  priceFilter: {
    monthly_lbl_low_to_high: "monthly Price - Low to high",
    monthly_lbl_high_to_low: "monthly Price - High to low",
  },
  lbl_pm: "PM",
  lbl_browse_all_prods: "Browse all products",
  lbl_all_categories: "All categories",
  lbl_deal_range: "Explore our deal range",
  lbl_filter_text:
      "Use the filters below to find exactly what you’re looking for",
  lbl_categories: "Categories",
  lbl_price: "Price",
  lbl_pagination_show_previous: "Show previous",
  lbl_pagination_show_more: "Show more",
  pagination_max_items_per_page: 12,
  deal_selection_pagination_max_per_page: 4,
  deal_selection_pagination_tablet_max_per_page: 3,
  order_history_max_items_per_page: 6,
  lbl_start_text: "Starting from",
  lbl_product_detail_indicator_note_postpaid:
      "* Please note Click & Collect may or may not be available, depending on what’s included in your order at checkout.",
  lbl_product_detail_indicator_note_prepaid:
      "* You’ll be able to select delivery or collection options at checkout.",
  lbl_do_an_upgrade_check: "Do an upgrade check",
  lbl_choose_upgrade_deal: "Choose upgrade deal",
  lbl_custom_dropdown_typeName: "CustomizableDropDownOption",
  lbl_custom_dropdown_prepaid_option: "once-off",
  lbl_custom_dropdown_prepaid_optionData: "Buy this product once off",
  lbl_custom_dropdown_deal_option: "contract",
  lbl_custom_dropdown_upgrade_option: "upgrade",
  lbl_custom_dropdown_upgrade_option_new_contract: "new-contract",
  lbl_payment_redirect: "Redirecting you to Vodacom Payment Services...",
  lbl_payment_failure_heading: "Something went wrong",
  lbl_payment_failure_description:
      "Your payment was not successful. Would you like to try again ?",
  lbl_payment_failure_note:
      "(Please check your card details on the next page to make sure there are no errors)",
  lbl_payment_failure_heading_error: "Payment unsuccessful",
  lbl_payment_failure_description_error_guest:
      "We were unable to process this transaction. Please check whether your card is valid and your account contains sufficient funds before trying again.",
  lbl_payment_failure_description_error:
      "We were unable to process this transaction. Please check whether your card is valid and your account contains sufficient funds. This order will be saved to your order history for 24 hours, in case you’d like to try again.",
  lbl_payment_failure_note_error:
      "Your item will be kept in your cart if you'd like to come back later and try again",
  lbl_payment_failure_heading_tech_error: "We've encountered a technical issue",
  lbl_payment_failure_description_tech_error:
      "Unfortunately we can't process your payment right now. Please try again later",
  lbl_checkout_unavailable:
      "Checkout is currently unavailable. Our team is aware of this issue and are working on it. Please try again later.",
  lbl_deal_selection_page_card_btn: "View deal details",
  lbl_go_to_order_page_btn: "Go to order history",
  lbl_back_to_top_btn: "Back to top",
  lbl_closed_order_type: "closed",
  lbl_order_details_header: "Order details",
  lbl_order_number: "Order number",
  lbl_order_date: "Order date",
  lbl_order_total: "Order total",
  lbl_order_status: "Order Status",
  lbl_order_placed_on: "Order placed on",
  lbl_order_type: "Order type",
  lbl_order_block_title: "Your order:",
  lbl_order_see_more_details: "See order details",
  lbl_estimated_delivery_date: "Estimated delivery date",
  lbl_estimated_delivery_date_mobile: "Est. delivery date",
  lbl_total_amount_paid: "Total amount paid",
  lbl_total_monthly_amount_paid: "Total due every month",
  lbl_amount_not_paid: "Not paid",
  lbl_delivery_address: "Delivery address",
  lbl_contact_person: "Contact person",
  lbl_courier: "Courier",
  lbl_way_bill_number: "Waybill number",
  lbl_your_purchased_items: "Your purchased items",
  lbl_log_a_return: "Log a return",
  lbl_track_this_order: "Track this order",
  lbl_complete_this_order: "Complete this order",
  lbl_retry_payment_order: "Retry payment",
  lbl_deal_selection_page: {
    lbl_heading: "Now, let’s find the perfect plan to go with your device…",
    lbl_heading_mobile:
        "Use the filters below to see the kind of deals you’re looking for:",
    lbl_filter_plan_type: "Plan type",
    lbl_filter_your_budget: "Your budget",
    lbl_filter_contract: "Contract type & duration",
    lbl_filter_monthly: "Data & voice minutes",
    lbl_filter_more: "+ More filters",
    lbl_more_filters: "More filters",
    lbl_plan_question: "What should your plan give you each month?",
    lbl_budget_question: "How much can you spend per month?",
    lbl_contract_question1: "Which type of contract do you prefer?",
    lbl_contract_question2: "How long should your contract be?",
    lbl_monthly_question1: "How much data do you need?",
    lbl_monthly_question2: "How many minutes do you need?",
    lbl_more_question: "More Filters",
    lbl_promotion_and_specials: "Promotions & specials",
    lbl_accessories_and_vouchers: "Accessories & vouchers",
    lbl_sort_heading: "Now, choose the deal you like the most:",
  },
  lbl_clear_button_text: "Clear",
  lbl_reset_button_text: "Reset",
  lbl_apply_button_text: "Apply",
  lbl_reset_all_filters: "Reset all filters",
  lbl_plan: "Plan",
  lbl_budget: "Budget",
  lbl_contract: "Contract",
  lbl_monthly: "Monthly",
  lbl_once_off: "Once-off",
  lbl_monthlyData: "Data",
  lbl_monthlyMinutes: "Minutes",
  lbl_more: "More",
  lbl_select: "- Select -",
  lbl_contractType: "ContractType",
  lbl_contractDuration: "ContractDuration",
  lbl_defaultPlanType: "Data & Voice",
  lbl_99999_min: "99999 min",
  lbl_unlimited: "Unlimited",
  lbl_order_history_header: "Your order history",
  lbl_track_my_order_header: "Track my order",
  lbl_all_years: "All years",
  lbl_reference_year: 2020,
  lbl_years: "Years",
  order_history_default_items_count: 6,
  lbl_view_order_details: "View order details",
  lbl_end_order_list: "That’s it! You’ve reached the end of this list.",
  lbl_show_more_orders: "Show more orders",
  lbl_show_more_deals: "+ Show more deals",
  lbl_show_more_products: "+ Show more products",
  lbl_load_more_orders: "+ Show more orders",
  lbl_order_total_colon: "Order total:",
  lbl_order_once_off_total: "Once-off total:",
  lbl_order_monthly_total: "Monthly total:",
  lbl_order_number_hash: "Order #",
  lbl_order_status_latest: "Latest order status:",
  lbl_order_reference_number: "Reference number:",
  lbl_orders_require_documents: "Documents we require:",
  lbl_past_orders: "past orders",
  lbl_zero_past_orders: "0 - 0 past orders",
  lbl_zero_items_default_text: "0 - 0 of 0 results",
  lbl_results: "Results",
  lbl_no_results_found: "No results found",
  lbl_order_history_info:
      "This is a list of all your previous online purchases, upgrades and contract applications",
  lbl_track_my_order_info:
      "Find out what your order’s current status is. You can track orders placed online or through our call centre.",
  lbl_promotions: "promotions",
  lbl_vouchers: "vouchers",
  lbl_mobile_filter_headers: {
    lbl_data_and_voice: "Data & voice",
    lbl_budget: "Set your budget",
    lbl_contract: "Select contract type & duration",
    lbl_monthly: "Select data & voice minutes",
  },
  lbl_storage: "storage",
  lbl_months: "months",
  lbl_color: "Color",
  lbl_Internal_Storage: "Internal Storage",
  lbl_internal_storage: "internal_storage",
  lbl_screen_size_pixels: "screen_size_pixels",
  lbl_apply_filter: "Apply filter",
  lbl_save_selection: "Save selection",
  lbl_top_up: "top up",
  lbl_standard_contract: "standard contract",
  errors: {
    lbl_something_went_wrong: "Something went wrong",
    lbl_technical_issue: "We’ve encountered a technical issue",
    lbl_contact_soon: "We’ll be in contact soon!",
    lbl_form_not_submitted: "Your form could not be submitted",
    lbl_try_again: "Please try again later.",
    lbl_form_not_submitted_check_error:
        "Your form could not be submitted. Please check for errors and try again.",
    lbl_form_not_submitted_fill_required:
        "Your form could not be submitted. Please fill all the required fields and try again.",
    lbl_something_went_wrong_try_again:
        "Something went wrong, please try again later.",
    lbl_deals_filter_error: "We seem to be having some issues fetching your search results. Please try again later.",
  },
  deal_details: {
    lbl_what_deal_gives: "So, what does this deal give me?",
    lbl_get_device: "You get this device...",
    lbl_you_get: "You get a…",
    lbl_review_deal: "Review your selected deal:",
    lbl_on_a: "on a",
    lbl_with: "with:",
    lbl_deal_includes: "This deal also includes…",
    lbl_contract_duration: "Contract duration:",
    lbl_deal_duration_price: "Deal duration & price:",
    lbl_deal_details: "Deal details",
    lbl_plan_details: "Plan details",
    lbl_device_plan_details: "Device & plan details",
    lbl_acc_voucher_details: "Accessory & voucher details",
    lbl_delivery_returns: "Delivery & returns",
    lbl_get_this_deal: "Get this deal",
    lbl_deal_to_cart: "Add deal to cart",
    lbl_deal_added: "This deal has been added to your cart",
    lbl_add_deal_cart: "Add deal to cart",
    lbl_upgrade_this_deal: "Upgrade to this deal",
    lbl_sim_size: "SIM card size:",
    lbl_total_monthly_due: "Total due every month:",
    lbl_vas_added: "has been added",
    lbl_vas_removed: "has been removed",
    device_data: {
      lbl_deal_price: "Deal price",
      lbl_contract_duration: "Contract duration",
      lbl_available_online: "Available online",
      lbl_available_store: "Available in-store",
      // lbl_available_stores: "Available in stores",
    },
    lbl_session_storage: "deal-buyOption",
    lbl_new_contract_deal_option: "Get this deal on a new contract",
    lbl_upgrade_deal_option: "Upgrade",
    lbl_upgrade_deal_option_lower_case: "upgrade",
    lbl_new_contract_deal: "New contract",
    lbl_new_contract_deal_vas: "+ Add contract / device insurance",

  },
  lbl_order_processing_state: "processing",
  lbl_order_pending_state: "pending",
  lbl_order_processing_l500_success_state: "processing_update_500_success",
  lbl_order_new_state: "new",
  lbl_data_only: "data only",
  order_status_labels: {
    lbl_processing: "Processing...",
    lbl_processed: "Order processed",
    lbl_paid: "Paid",
    lbl_order_error: "Order error",
    lbl_payment_failed: "Payment failed",
    lbl_cancelled: "Order cancelled",
    lbl_in_progress: "In Progress",
    lbl_payment_pending: "Payment Pending",
    lbl_pending: "Pending",
    lbl_order_failed: "Order Failed",
    lbl_payment_unsuccessful: "Payment Unsuccessful",
    lbl_new: "New",
    lbl_order_created: "Order Created",
  },
  order_blurb_labels: {
    lbl_will_be_cancelled:
        "This order will be cancelled in 23h 24m. Please retry payment to avoid cancellation.",
    lbl_retry_order:
        "This order will be cancelled in 23h 24m. Please retry payment to avoid cancellation.",
    lbl_consultant_touch: "A consultant will get in touch with you",
    lbl_settlement_failed: "Payment settlement failed",
    lbl_payment_received: "Payment was received and settled",
  },
  order_messages_labels: {
    lbl_will_be_cancelled:
        "Something went wrong while processing your order. Please press the 'Retry payment' button above to submit your order for processing again. If you don't resubmit, this order will be cancelled after 24 hours.",
    lbl_is_cancelled:
        "We couldn't finish processing this order due to a technical error",
    lbl_consultant_touch:
        "Something went wrong while processing your order. One of our consultants will contact you in order to resolve this issue.",
    lbl_consultant_phone: "One of our consultants will contact you on",
    lbl_settlement_failed:
        "Your payment could not be settled successfully. The payment authorisation on your account will be reversed within 5 - 10 days, depending on your bank. In the meantime, we'll continue processing your contract application separately. Please contact your bank for more information. Alternatively, you can contact Customer Care at 08217844.",
  },
  lbl_airtime: "airtime",
  lbl_buy_bundle: "Buy Bundle",
  lbl_Months: "months",
  lbl_select_deal: "Choose a deal",
  lbl_build_contract: "Build your contract",
  lbl_internal_search: {
    lbl_search_see_all: "See all product results",
    lbl_search_see_all_deals: "See all deals results",
    lbl_all_result: "All results",
    lbl_promotions: "Promotions",
    lbl_products: "Products",
    lbl_deals: "Deals",
    lbl_services: "Services",
    lbl_content_video: " Content & Videos",
    lbl_help_support: "Help & Support",
    lbl_latest_products: "Latest products",
    lbl_bestselling_products: "Bestselling products",
    lbl_latest: "latest",
    lbl_bestSelling: "Bestselling",
    lbl_tab_names: {
      lbl_allresults: "all-results",
      lbl_products: "products",
      lbl_deals: "deals",
      lbl_promotions: "promotions",
      lbl_content_videos: "content-videos",
      lbl_content_and_videos: "content & videos",
      lbl_help_support: "help-support",
      lbl_services: "services",
    },
    lbl_showing3_result: "Showing 3 of ",
  },
  lbl_results_found: "results found",
  lbl_past_orders_found: "past orders",
  lbl_result_found: "result found",
  lbl_see_all: "See all results",
  lbl_cart_recently_viewed: "You recently viewed:",
  lbl_there_is_no_match: "There's no match for",
  lbl_could_not_render_page: "could not render page template",
  lbl_you_will_save: "You'll save",
  lbl_order_waiting: "You still have an order waiting to be completed",
  lbl_order_not_final:
      "Your previous order was not finalised successfully. Would you like to complete it now?",
  lbl_hurry_text:
      "Hurry! This order will be automatically cancelled 24 hours after it was created.",
  lbl_view_order: "View order",
  lbl_complete_order: "Complete order now",
  lbl_search_no_result: "search_no_result",
  errorMessages: {
    lbl_filters_did_not_load_error:
        "Oops! These filters did not load correctly this time. Please try loading the page again.",
    lbl_page_error: "Oops! This page could not be loaded correctly.",
    lbl_page_error_subheading1:
        "We're currently experiencing technical issues, or this page might be down for maintenance.",
    lbl_page_error_subheading2:
        "Either way, our team is on it and will have it up and running again soon!",
    lbl_user_profile_sync:
        "Something went wrong. It seems the product could not be added to your cart. Please try again later.",
    lbl_back_order_deal_unavailable: "Unfortunately, this product is currently unavailable. You can continue to browse more deals.",
  },
  lbl_menu_top: {
    lbl_switch_business: "Switch to business",
    lbl_find_store: "Find a store",
    lbl_page_error_subheading1:
        "We're currently experiencing technical issues, or this page might be down for maintenance.",
    lbl_page_error_subheading2:
        "Either way, our team is on it and will have it up and running again soon!",
    lbl_product_404_heading: "This product is no longer available",
    lbl_product_404_label: "Currently out of stock",
    lbl_product_404_description:
        "Try browsing all our products to find something similar",
    lbl_deal_404_heading: "Deal expired",
    lbl_deal_404_description:
        "Try browsing all our deals to find something similar",
    lbl_user_profile_sync:
        "Something went wrong. it seems the product could not be added to your cart. Please try again later.",
  },
  lbl_upgrade_page_heading: "Let’s see if you can upgrade today",
  lbl_upgrade_page_heading_mobile: "Upgrade check",
  lbl_upgrade_page_description:
      "Enter your details below to see if you’re able to upgrade your contract today:",
  lbl_which_number: "Which number do you want to upgrade?",
  lbl_which_number_mobile: "Which number are you upgrading?",
  lbl_i_can_receive_sms: "I can receive an SMS on this number",
  lbl_what_to_expect: "Wondering what to expect?",
  lbl_what_to_expect_data: [
    {
      id: "1",
      text: `If you are eligible for an upgrade, we’ll show you a set of <span class="expect-text">Just4You deals</span> that have been specially recommended for you <span class="expect-text">based on your previous usage</span>`,
    },
    {
      id: "2",
      text: `If you don’t like any of the recommended deals, you can still browse <span class="expect-text">other deals </span>on our website that you qualify for`,
    },
    {
      id: "3",
      text: `We <span class="expect-text">don’t require any documents</span> during the online upgrade process`,
    },
  ],
  checkout: {
    lbl_merge_cart_error_title: "We see you’ve got more items in your cart",
    lbl_merge_cart_error_desc:
        "You previously added one or more items to your cart when you were logged in. Would you like to view those items now, or would you like to clear your cart and continue with your current checkout?",
    lbl_session_invalid:
        "Your session seems to be expired. Please refresh to re-login, and try again.",
    lbl_cart_invalid:
        "Your cart seems to be expired. Please refresh and try again.",
    lbl_technical_error_title: "We’ve encountered a technical issue",
    lbl_technical_error_desc:
        "Unfortunately, we can’t proceed with your application right now. Please try again later, or let us give you a call to help complete your application telephonically.",
    lbl_something_went_wrong_try_again:
        "Something went wrong. Please try again.",
    lbl_invalid_attempt_title: "Something went wrong",
    lbl_invalid_attempt_desc:
        "Unfortunately, we can’t proceed with your application right now. Please try again later, or let us give you a call to help complete your application telephonically.",
    lbl_no_deal_product:
        "It seems their is no deal product in your cart. Please add a deal product to proceed further.",
    lbl_select_preference: "Please select your preference below:",
    lbl_preference_values: [
      {
        id: "call-me-back",
        label: "I want a consultant to call me back",
        analyticsLabel: "call me back",
      },
      {
        id: "once-off",
        label: "I still want to check out my once-off purchase items",
        analyticsLabel: "once-off",
      },
      {
        id: "all-above",
        label: "All of the above",
        analyticsLabel: "all of the above",
      },
    ],
    lbl_preference_approved_conditions_values: [
      {
        id: "select-another-deal-need-once-off",
        label:
            "Let me select another deal to apply for. I’ll check out my once-off purchase items afterwards.",
        analyticsLabel: "check once-off after",
      },
      {
        id: "select-another-deal-dont-need-once-off",
        label:
            "Let me select another deal to apply for. I don’t need the once-off purchase items anymore.",
        analyticsLabel: "remove once-off",
      },
      {
        id: "check-once-off-only",
        label: "I only want to check out my once-off purchase items now",
        analyticsLabel: "once-off only",
      },
    ],
    lbl_will_be_in_touch: "We'll be in touch soon!",
    lbl_continue_once_off:
        "Would you like to continue with the purchase of the once-off items in your order?",
  },
  delivery: {
    contractTypeContactFormInfo:
        "Please enter your own contact details. For security reasons, the courier needs to deliver this order to the person applying for the contract.",
  },
  payment: {
    removeCreditCard:
        "Your credit / debit card has been removed from your profile",
    removeCreditCardFail: "Something went wrong. Please try again.",
    noCreditCardWarning:
        "We’re not able to show your previously saved cards right now. You can still continue to the next page and enter/select your card details there.",
  },
  orderConfirmation: {
    lbl_contract_default_desc:
        "Your application has been submitted. Someone will be in touch soon to confirm your application result.",
    lbl_contract_upgrade_desc: "Your upgrade has been submitted",
    lbl_normal_sub_desc:
        "As soon as your payment has been approved and confirmed, we’ll send you a confirmation email with all your order and delivery details.",
    lbl_your_order_should_delivered:
        "Your order should be delivered in the next:",
    lbl_your_reference_number: "Your reference number:",
    lbl_cqfd_order_fail_heading: "Something went wrong",
    lbl_cqfd_order_fail_description:
        "Unfortunately, there was a technical issue with your previous online application. A consultant will contact you soon to help you complete your application.",
    lbl_order_fail_heading: "We’ve encountered a technical issue",
    lbl_order_fail_description:
        "Unfortunately, we can’t proceed with your application right now. Please try again later, or let us give you a call to help complete your application telephonically.",
    lbl_order_fullfilment_stock_dependant:
        "Fulfilment of orders is stock-dependant at the time of application approval.",
    lbl_we_need_documents: "We need a few documents",
    errorCodes: {
      newLineApproved: "order-confirmation-newline-approved",
      newLineOffline: "order-confirmation-newline-offline",
      newLinePendedId: "order-confirmation-newline-pended-id",
      newLinePendedPassport: "order-confirmation-newline-pended-passport",
      newLineApprovedWithConditions:
          "order-confirmation-newline-approved-with-conditions",
      addLineApproved: "order-confirmation-addline-approved",
      addLineOffline: "order-confirmation-addline-offline",
      addLinePendedId: "order-confirmation-addline-pended-id",
      addLinePendedPassport: "order-confirmation-addline-pended-passport",
      addLineApprovedWithConditions:
          "order-confirmation-addline-approved-with-conditions",
      upgradeApproved: "order-confirmation-upgrade-approved",
    },
  },
  auth: {
    lbl_technical_error_title: "We’ve encountered a technical issue",
    lbl_technical_error_desc:
        "Unfortunately, we can’t proceed with your application right now. Please try again later.",
    lbl_tooltip_message:
        "The main account holder is the person responsible for paying the account, and their associated number is typically their very first Vodacom contract number",
    errorCodes: {
      api_time_out: "letsGetStarted_504",
    },
    lbl_email_readOnly:
        "We’ll use this email address from your Vodacom profile to communicate with you regarding your order",
  },
  xds: {
    lbl_info: [
      "We use a third party service and your ID number to source these questions and answers from the Department of Home Affairs and the credit bureau",
    ],
    lbl_success_title: "Your application has been successfully authenticated",
    lbl_failed_title:
        "We will authenticate you once your application has been submitted",
    lbl_error_title:
        "We seem to be having some technical issues right now. We'll authenticate your application once its been submitted.",
    lbl_success_desc: null,
    lbl_failed_desc:
        "Not all your answers to the security questions were correct. You can still continue completing your application - we'll simply authenticate your application after you've submitted it",
    lbl_error_desc: null,
    lbl_question_fetching_title: "Fetching your questions...",
    lbl_checking_answer_title: "Checking your answers...",
  },
  lbl_error_block_API_fail:
      "Oops! This page didn’t load correctly. Please try reloading the page to see everything as it should be.",
  lbl_top_banner: {
    lbl_busy_upgrade: "You are busy with upgrading your contract",
    lbl_Process_upgrade:
        "<span class='upgrade-cancel-nr'>No worries if you don't want to upgrade {{cellphone}} right now.</span> " +
        "You can explore new contracts or even upgrade a different number!",
    lbl_process_upgrade_title: "Change your mind?",
    lbl_no_longer_upgrade_title: "You're no longer upgrading your contract",
    lbl_no_longer_upgrade_msg:
        "Want to continue upgrading again? You can navigate to the Upgrade page from the main menu, or you can select the upgrade option when choosing your device or deal.",
    lbl_btn: {
      lbl_see_detail: "See More Details",
      lbl_stop_upgrade: "I don’t want to upgrade right now",
      lbl_start_upgrade: "I want to upgrade another number",
      lbl_recommended_deals: "I want to get a new contract",
      lbl_okay_got_it: "Okay, got it",
    },
  },
  lbl_transfer_number: {
    lbl_phone_number: "Which number would you like to use?",
    lbl_new_number: "I’d like a new number",
    lbl_vodacom_number: "I have a Vodacom prepaid number",
    lbl_external_number: "I have a prepaid number from another network",
    lbl_retry_button: "Try another prepaid number",
    lbl_retry_button2: "Use another number instead",
    lbl_agree_1:
        "I agree that the number above is a prepaid number and it belongs to me",
    lbl_agree_2:
        "I agree to receive a new number if this number cannot be transferred successfully",
    lbl_agree_3:
        "I agree to forfeit any airtime or bundles on this number when it is transferred",
    lbl_important_things: "Important things to know",
  },
  lbl_upgrade_info_banner:
      "These deals were recommended for you based on your past usage and affordability",

  //upgrade
  upgrade: {
    lbl_invalid_otp_try_1:
        "Looks like you entered an invalid OTP. Please try again.",
    lbl_invalid_otp_try_2:
        "Looks like you entered an invalid OTP again. You have one attempt remaining. Please try again.",
    lbl_invalid_otp_try_3:
        "For your security, you've been temporarily blocked from requesting new OTPs. Please try again in 24 hours.",
    lbl_invalid_otp_try_3_desc:
        "For your security, you've been temporarily blocked from requesting new OTPs. Please try again in 24 hours.",
    lbl_invalid_otp_try_3_title: "You’ve entered 3 invalid OTPs",
    lbl_invalid_otp_try_3_btn_title: "You’ve entered 3 invalid OTPs",
    lbl_enter_msisdn_title: "Let’s see if you can upgrade today",
    lbl_enter_msisdn_desc:
        "Please enter the cellphone number that you’d like to upgrade below:",
    lbl_enter_msisdn_input_title: "Your cellphone number",
    lbl_enter_msisdn_checkbox_text: "I can receive an SMS on this number",
    lbl_enter_otp_title: "Please enter your 6-digit OTP",
    lbl_enter_otp_desc_prefix: "We’ve sent a One-Time PIN (OTP) to",
    lbl_enter_otp_desc_suffix: ". Please enter it below to continue:",
    lbl_enter_otp_desc_suffix_v2: "Please enter it below to continue:",
    lbl_btn_resend_otp: "Resend",
    lbl_btn_continue: "Continue",
    lbl_select_number_title: "Where can we send your OTP?",
    lbl_select_number_desc:
        "We need to send you a One-Time PIN (OTP) to authenticate this application. On which number you would like to recive your OTP?",
    lbl_btn_none_otp: "None of these numbers can receive SMS OTPs",
    lbl_otp_resent_info:
        "Your One-Time PIN has been resent. Please check your inbox.",
    lbl_tooltip_message:
        "The main account holder is the person responsible for paying the account, and their associated number is typically their very first Vodacom contract number",
    lbl_tooltip_prefix_text: "Yes, the",
    lbl_tooltip_text: "main account holder",
    lbl_tooltip_suffix_text: " will be able to provide an OTP",
    lbl_error_zero: "Number must start with 0 or 27",
    lbl_error_numbers: "This field can only contain numbers",
    lbl_error_enter_number: "Please enter your cellphone number",
    lbl_snackbar_title: "Hey, you can upgrade!",
    lbl_snackbar_desc:
        "That’s right! The wait is finally over. Click through to upgrade your contract right here, right now.",
    lbl_snackbar_btn_text: "See upgrade deals",
    lbl_still_upgrading: "Are you still upgrading?",
    lbl_processing_desc:
        "You’re currently in the process of selecting an upgrade deal. Would you like to stop your upgrade and apply for a new contract instead?",
    lbl_continue_upgrade: "Continue upgrading",
    lbl_apply_new_contract: "Apply for a new contract",
    lbl_do_upgrade: "Do an upgrade check",
    lbl_here_to_do_upgrade: "Here to do an upgrade?",
    lbl_products_qualify: "Browse products you qualify for",
    lbl_deals_qualify: "Only show deals I qualify for",
    lbl_deals_for_upgrade:
        "Based on your profile, these are the deals you can upgrade to",
    lbl_deals_no_products:
        "Unfortunately, there are no deals that you qualify for right now",
    lbl_upgrade_due_info:
        "Once we’ve checked if you’re due for an upgrade, and if this is a qualifying upgrade deal for you, you’ll be able to add it to your cart and continue to checkout",
    lbl_upgrade_qualify_info:
        "Once we’ve checked if this is a qualifying upgrade deal for you, you’ll be able to continue to checkout",
    lbl_prod_upgrade_qualify_info:
        "Next, you’ll be presented with all our contract deals for this month, which you can filter and browse until you find the one that suits you best.",
    lbl_prod_upgrade_due_info:
        "Once we’ve checked if you’re due for an upgrade, you’ll be able to select from a range of deals for this product that you already qualify for.",
    lbl_upgrade_add_to_cart_info:
        "Once we’ve checked if this is a qualifying upgrade deal for you, you’ll be able to add it to your cart and continue to checkout",
    lbl_home_btn: "Go to home page",
    lbl_addnl_info:
        "You can upgrade another number! Check the dropdown above to see which of your numbers are upgradable right now.",
    lbl_see_deals_btn: "See all deals I qualify for",
    lbl_btn_submit_otp: "Submit OTP",
    lbl_see_products_btn: "See all devices I qualify for",
    lbl_cant_upgrade: "You can't upgrade now.",
    lbl_find_out_why: "Find out why",
    lbl_afford_title:
        "You can upgrade, but there are no qualifying deals for this device",
    lbl_afford_desc:
        "Unfortunately, based on your customer profile, we couldn’t find any upgrade deals for this device that you currently qualify for. Would you like to see your available upgrade deals?",
    lbl_afford_btn: "Show me deals I qualify for",
    lbl_reset_desc:
        "We couldn't find any results for your selected filters. Try widen your search by changing some of your selections, or reset all filters below.",
    lbl_no_products:
        "Unfortunately, there are no deals that you qualify for right now",
    lbl_scroll_desc:
        "The wait is finally over! Scroll down to choose the perfect upgrade deal for you.",
    lbl_upgrade_number: "Upgrade this number",

    planData: {
      lbl_looking_for: "I’m looking for...",
      lbl_contract_with_device: "A contract with a device",
      lbl_contract_sim_only: "A SIM only contract",
    },
    stages: {
      lbl_number_entry: "number entry",
      lbl_otp_entery: "otp entry",
      lbl_number_select: "number select",
      lbl_upgrade_result: "upgrade result",
      lbl_technical_error: "technical error",
      lbl_eligible_number_select: "eligible number select",
    },
    errorCodes: {
      code_user_not_found: "upgradeeligibility_other_na_011",
      code_invalid_otp_error: "upgradeeligibility_otp_invalid",
      code_otp_service_down: "upgradeeligibility_otp_500",
      code_otp_no_alternative: "upgradeeligibility_otp_no_alternative",
      code_service_down: "upgradeeligibility_other_na_500",
      code_logged_user_service_down: "upgradeeligibility_logged_500",
      code_mah_user_upgradable: "upgradeeligibility_c3d_mah_000",
      code_child_user_upgradable: "upgradeeligibility_c3d_child_000",
      code_user_duefor_upgrade: "012",
      code_user_duefor_upgrade_with_null: "upgradeeligibility_c3d_na_null",
      code_deal_not_affordable: "upgradeaffordability_dealdetails_fail",
      code_product_not_affordable: "upgradeaffordability_productdetails_fail",
      code_user_acc_error: "upgradeeligibility_other_na_001",
      code_credit_filter_error: "upgradeeligibility_affordability_technical",
      code_cbu_staff_not_eligible: "upgradeeligibility_other_na",
    },
  },
  creditCheckout: {
    lbl_invalid_attempt_1:
        "Your bank account details seem to be invalid. Please check for errors and try again.",
    lbl_invalid_attempt_1_multicart:
        "Your bank details seem to be invalid. Please check for errors and try again.",
    lbl_invalid_attempt_2:
        "Your bank account details seem to be invalid. You have one attempt remaining. Please check for errors and try again.",
    lbl_invalid_attempt_3:
        "You’ve entered invalid account details for a third time. Let us give you a call and help you complete your application telephonically.",
    lbl_invalid_attempt_3_title: "Invalid bank account details",
    lbl_invalid_attempt_4:
        "Looks like this account cannot be debited. Please check for errors or try another account number.",
    lbl_bank_page_warning:
        "Please use your own bank account details for this application. We can only verify your bank account if it was opened using your ID/passport number.",
    lbl_warning_contents: [
      "The account number matches the selected account type",
      "The account can be debited",
      "The account is currently active",
    ],
    lbl_debicheck_mandate:
        "To protect your account from fraudsters, DebiCheck lets you authorise debit orders electronically before transactions are processed. It's an extra layer of security for your peace of mind.",
    lbl_debicheck_mandate_multicart:
        "To protect your account from fraudsters, DebiCheck lets you authorise debit orders electronically before transactions are processed. It's an extra layer of security for your peace of mind.",
    deliveryDetails: {
      lbl_receive_type_title: "How would you like to receive your order?",
      lbl_delivery_type_title: "Where should we have it delivered?",
      lbl_another_address_title: "Please enter your delivery address below:",
      lbl_courier_title: "The courier will contact you on:",
      lbl_store_title: "Collecting from a store",
      lbl_store_contents: [
        "<p>We’ve made sure <strong>we only show you stores that have your items in stock.</strong> If you can’t find your favourite store below, it may be that they don’t have stock right now.</p>",
        "<p>The store you choose will let you know <strong>when your order is ready for collection.</strong> It normally takes 1 - 3 days to prepare your order.</p>",
        "<p>Collections can be made <strong>during normal store operating hours.</strong></p>",
      ],
      lbl_collect_type_title: "Where would you like to collect your order?",
      lbl_store_search_title:
          "Try searching for your town, suburb or favourite shopping centre",
      lbl_invalid_attempt_title: "Something went wrong",
      lbl_invalid_attempt_desc:
          "Unfortunately, we can’t proceed with your application right now. Please try again later, or let us give you a call to help complete your application telephonically.",
    },
  },
  creditVetting: {
    lbl_code_approved: "Approved_Vetting_Outcome",
    code_approved_with_condition: "Approved_Conditions_Vetting_Outcome",
    code_p50_affordability: "P50_Approved_Conditions_Outcome",
    code_unaffordability: "Deal_Details_Unaffordability_Error",
    lbl_p50_error_code: "P50_Approved_With_Conditions",
    lbl_available_deals:
        "Based on your last credit check, these are the deals you can apply for",
    lbl_qualify: "Only show deals I qualify for",
    lbl_loading_screen_msg:
        "Checking your credit status with registered credit bureaus…",
    lbl_loading_screen_msg_multicart:
        "Checking your credit status with registered credit bureaus…",
    lbl_approved_with_condition: "Approved_With_Conditions",
    lbl_form_content_not_found: "consentFormContentNotFound",
    lbl_chk_consent: "give consent",
    lbl_chk_agree: "above is correct",
    lbl_processed: "PROCESSED",
    lbl_unprocessed: "UNPROCESSED",
    lbl_approved: "APPROVED",
    lbl_declined: "DECLINED",
    lbl_referred: "REFERRED",
    lbl_pended: "PENDED",
    lbl_pending: "PENDING",
    lbl_screentype_loading: "loadingScreen",
    lbl_approved_with_condition_status: "APPROVED WITH CONDITIONS",
    lbl_resultcode_approved_with_condition:
        "CreditVetting_APPROVED WITH CONDITIONS",
    lbl_resultcode_approved: "CreditVetting_APPROVED",
    lbl_resultcode_offline: "CreditVetting_OFFLINE",
    lbl_resultcode_offline_unprocessed: "Unprocessed_Vetting_Result",
    lbl_resultcode_declined_nxtlvl: "CreditVetting_DECLINED_NXTLVL",
    lbl_resultcode_declined: "CreditVetting_DECLINED",
    lbl_resultcode_referred: "CreditVetting_REFERRED",
    lbl_resultcode_pended: "CreditVetting_PENDED",
    lbl_resultcode_pending: "CreditVetting_PENDING",
    lbl_declined_passport: "Declined_Non-NXT_LVL",
    lbl_declined_non_nxtlvl: "Declined_LeadNXT_LVL",
    lbl_pending_non_nxtlvl: "Declined_Non-NXT_LVL_Pended",
    lbl_referred_non_nxtlvl: "Declined_Non-NXT_LVL_Referred",
    lbl_lead_submitted: "Lead_Submitted",
    approvedWithCodition: {
      lbl_technical_error_title:
          "Your credit check has been approved, but not for this deal...",
      lbl_technical_error_desc:
          "You have the option to choose a different deal from a range of deals that have been selected based on your credit check result. Would you like to continue to choose another deal?",
      lbl_primary_button: "Yes, show me other deals",
      lbl_secondary_button: "Exit checkout",
    },
    approved: {
      lbl_title: "Your credit status has been approved!",
      lbl_desc: "You can now continue with your application.",
      lbl_screentype: "Approved_Vetting_Outcome",
    },
    lbl_submit_docs_info:
        "Once you’ve submitted your application we’ll tell you which documents we require and where you can send them. The outcome of your application will be communicated with you after we’ve received and processed your documents.",
    lbl_split_cart_notification_message:
        "<strong>We need to check out your order in two parts</strong><br/>Your once-off purchase items will be moved back to your cart for now, and you can check them out after submitting your application.",
  },
  product_affordability: {
    lbl_upgrade_banner: "You’re upgrading ",
    lbl_upgrade_banner_mobile: "You're upgrading {contract_label}",
    lbl_available_deals:
        "Based on your credit profile, these are the available deals you can apply for",
    lbl_available_products:
        "Based on your credit profile, these are the products on the available deals you can apply for",
    lbl_available_products_tablet:
        "Based on your profile, these are the products with deals you can upgrade to",
    lbl_available_deals_tablet:
        "Based on your profile, these are the products with deals you can upgrade to",
    lbl_qualify: "Only show devices I qualify for",
    lbl_qualify_device_plan:
        "Based on your credit profile, we can offer you deals with a device and a plan",
    lbl_qualify_sim_only:
        "Based on your credit profile, we can offer you SIM-only deals and possibly deals that include a device and plan",
    lbl_qualify_limited_deals:
        "Based on your credit profile, we can offer you deals with a limited range of devices and plans",
    lbl_no_deals_available:
        "Unfortunately, there are no deals that you qualify right now.",
    lbl_do_upgrade: "See Details",
    lbl_qualify_deals_plan:
        "Based on your credit profile, we can offer you deals with a device and a plan",
    lbl_busy_mobile: "You’re upgrading",
  },
  mah_authentication: {
    lbl_success_title: "Your upgrade has been successfully authorised!",
    lbl_mah_info:
        "The main account holder is the person responsible for paying the account, and their associated number is typically their very first Vodacom contract number",
    lbl_enter_otp_title: "Please enter your OTP below:",
    lbl_enter_mah_otp_title:
        "Please enter the main account holder’s OTP below:",
    lbl_where_to_sent_otp: "Where should we send the OTP?",
    lbl_select_number:
        "Please select the number to which we can send the One-Time PIN (OTP) below:",
    lbl_one_time_pin: "One-time PIN:",
    lbl_validate_otp: "Validate OTP",
    lbl_resend_otp: "Resend OTP",
    lbl_havent_received_otp: "Haven’t received your OTP SMS yet?",
    lbl_otp_sent_desc_1: "Your OTP was sent to",
    lbl_otp_sent_desc_2:
        ". If this is a data SIM, or you can’t receive an SMS on this number, one of our consultants will need to call you.",
    lbl_cant_receive_otp: "I can’t receive an SMS on this number",
    lbl_send_otp: "Send OTP",
    lbl_call_me_back: "Call me back",
    lbl_will_send_otp:
        "We’ll be sending you a One-Time PIN (OTP) in order for you to authorise this upgrade",
    lbl_mah_auth: "Main account holder authorisation",
    lbl_mah_auth_desc:
        "We’ll be sending a One-Time PIN (OTP) to the main account holder in order for them to authorise this upgrade. Once they’ve received it, please enter it below to continue.",
    lbl_send_otp_other: "Send OTP to another number",
    lbl_pay_my_bill: "Pay my bill",
  },
  post_checkout: {
    otp_authentication: {
      lbl_main_heading: "Authorise adding a contract",
      lbl_sub_heading: "We've sent a One-Time PIN (OTP) to ",
      lbl_sub_heading_2:
          " in order for you to authorise the addition of this contract",
      lbl_input_title: "Please enter your OTP below:",
      lbl_resend_otp: "Resend OTP",
      lbl_validate_otp: "Validate OTP",
      lbl_call_me_back: "Call Me Back",
      lbl_otp_message_title: "Haven't received your OTP SMS yet?",
      lbl_otp_message_desc:
          "Your OTP was sent to {masked_msisdn}. If this is a data SIM, or you can't receive an SMS on this number, one of our consultants will need to call you.",
      lbl_otp_message_link: "I can't receive an SMS on this number",
      lbl_otp_multiple_mah_title: "Where should we send the OTP?",
      lbl_otp_multiple_mah_subheading:
          "Please select the number to which we can send the One-Time PIN (OTP) below:",
      lbl_otp_sms_receive_checkbox: "I can receive an SMS on this number",
      lbl_otp_send_btn: "Send OTP",
      lbl_otp_sent_to_another: "Send OTP to another number",
      lbl_otp_success: "Your application has been successfully authorised!",
      lbl_otp_3_try_title: "You've entered 3 invalid OTPs",
      lbl_otp_3_try_desc:
          "For your security, you've been temporarily blocked from requesting new OTPs.  Please try again in 24 hours, or have one of our consultants call you to assist you telephonically.",
      lbl_otp_resent_info:
          "Your One-Time PIN has been resent. Please check your inbox.",
      lbl_otp_cannot_send: "We can't send you a One-Time PIN",
      lbl_otp_cannot_send_desc:
          "Unfortunately, you don't have a Vodacom number that can receive an OTP linked to your profile. One of our consultants can contact you to help you apply for this contract telephonically.",
    },
  },
  lbl_success_auth: "You’ve been authenticated for this upgrade",
  lbl_success_approved: "You’ve been approved for this contract"
};
export default labels;
